<script>
import Money from "@src/mixins/money";

export default {
  mixins: [Money],
  props: {
    financial: {
      type: Object,
      required: true,
    },
    fees: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    rows() {
      const toCurrency = (value) => {
        const amount = value || 0;
        return `R$ ${amount ? this.formatMoney(amount) : "0,00"}`;
      };

      return [
        {
          id: 'total_value',
          label: "Valor total da venda",
          value: toCurrency(this.financial.total_value),
        },
        {
          id: 'net_value',
          label: "Valor líquido recebido",
          value: toCurrency(this.financial.net_value),
        },
        {
          id: 'seller_value',
          label: "Valor distribuído ao vendedor",
          value: toCurrency(this.financial.seller_value),
        },
      ];
    },
  },

  data() {
    return {
      financialFields: [
        { key: "label", label: "", thStyle: { width: "50%" } },
        { key: "value", label: "", thStyle: { width: "50%" } },
      ],
      feesFields: [
        { key: "label", label: "Descrição (exibição)" },
        {
          key: "type",
          label: "Campo técnico",
          thClass: "text-left",
          tdClass: "text-left",
        },
        { key: "value", label: "Valor", thClass: "text-right", tdClass: "text-right" },
      ],
      feesTypes: {
        SELLER_FEE: "Taxa da plataforma (Greenn)",
        ANTECIPATION_FEE: "Taxa de antecipação (da venda)",
        COST_GATEWAY: "Custo do gateway",
        FEE_GATEWAY: "Tarifa do gateway",
        SELLER_FEE_INTERNATIONAL: "Taxa internacional",
        AFFILIATE_FEE: "Comissão de afiliado",
        SELLER_INTEREST_FEE: "Juros do parcelamento (vendedor)",
        USER_ANTECIPATION_FEE: "Taxa de antecipação (usuário)",
        COUNTRY_FEE: "Taxa de conversão/país",
      },
    };
  },
};
</script>

<template>
  <div class="card-box p-3 px-0 sales-next-financial">
    <div class="financial financial--noheader">
      <h6 class="sales-details__subtitle financial__subtitle">Informações Financeiras</h6>
      <b-table
        class="sales-details__table"
        :items="rows"
        :fields="financialFields"
        headless
        bordered
        small
      >
        <template #cell(label)="data">
          <span :class="{'seller--label': data.item.id === 'seller_value'}">{{ data.item.label }}</span>
        </template>

        <template #cell(value)="data">
          <div :class="{'seller--value': data.item.id === 'seller_value'}" class="d-flex justify-content-end">
            {{ data.item.value }}
          </div>
        </template>
      </b-table>
    </div>
    <div class="fees">
      <h6 class="sales-details__subtitle">Taxas aplicadas</h6>
      <b-table
        class="sales-details__table"
        :items="fees"
        :fields="feesFields"
        headless
        bordered
        small
      >
        <template #cell(label)="data">
          <span>{{ feesTypes[data.item.type] || `Taxa não mapeada: ${data.item.type}` }} </span>
        </template>

        <template #cell(type)="data">
          <div class="fees__badge">
            {{ data.item.type }}
          </div>
        </template>

        <template #cell(value)="data">
          <div class="d-flex justify-content-end">
            - R$ {{ formatMoney(data.item.value) || "0,00" }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<style lang="scss">
.sales-next-financial {
  .financial {
    &--noheader {
      thead {
        display: none;
      }
    }

    &__subtitle {
      margin-bottom: 1rem;
    }
  }

  .fees {
    &__badge {
      width: fit-content;
      background: #eff6ff;
      color: #1a52db;
      border-radius: 8px;
      padding: 6px 8px;
      font-weight: 600;
    }
  }

  .seller--label {
    color: #000C0B;
  }

  .seller--value {
    color: #005952;
    font-weight: bold;
  }
}
</style>
